import { Component } from '@angular/core';
import { MessagesGeneral, MessagesStatus } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { ListadoFacturasVencidasComponent } from './listado-facturas-vencidas/listado-facturas-vencidas.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-rep-cobranzas',
  templateUrl: './rep-cobranzas.component.html',
  styleUrls: ['./rep-cobranzas.component.scss'],
  providers:[MessagesGeneral, MessagesStatus,
    DatePipe,ListadoFacturasVencidasComponent]
})
export class RepCobranzasComponent{

  constructor(private loginService: LoginService,
    private carga: ListadoFacturasVencidasComponent ) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
    this.carga.ExportTOExcel()
   }
}
